import React from "react";
import dompurify from "dompurify";
import PageWrapper from "../../PageWrapper";
import PrimaryButton from "../../SFUCentralThemedComponents/PrimaryButton";
// import Checkbox from "../GenericFormikComponents/Checkbox";
// import CheckboxGroup from "../GenericFormikComponents/CheckboxGroup";
// import Label from "../Label";
import ProgressSpinnerPR from "../../PrimeReact/ProgressSpinnerPR";

import { useScholarshipId } from "../../../hooks/useScholarshipId";
import LoadingPage from "../../LoadingPage";

// import { validationSchema, initialValues } from "./validationSchema";

export default function InitialConsentPage({
  savePage,
  scholarshipAppData,
  spinnerStatus,
}) {
  const scholarshipData = useScholarshipId();

  if (scholarshipData.isLoading) {
    return <LoadingPage />;
  }

  return (
    <PageWrapper>
      <div className="p-grid">
        <div className="p-col-12">
          <h1>Introduction</h1>
        </div>

        <div className="p-col-12">
          <p>{`Welcome to the Uggla Family Scholarship Application, ${scholarshipAppData.data.first_name} ${scholarshipAppData.data.last_name}.`}</p>

          {scholarshipData.data.application_introduction_page_text ? (
            // eslint-disable-next-line react/no-danger
            <div
              dangerouslySetInnerHTML={{
                __html: dompurify.sanitize(
                  scholarshipData.data.application_introduction_page_text
                ),
              }}
            />
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="p-grid button-navigation-container">
        <div className="p-col-12">
          <PrimaryButton
            type="submit"
            classname="push-right"
            onClick={() => {
              savePage({ is_consented: 1 });
            }}
          >
            Begin Application
          </PrimaryButton>
        </div>
      </div>
      {spinnerStatus ? <ProgressSpinnerPR /> : ""}
    </PageWrapper>
  );
}
